
  import {Component, Vue} from 'vue-property-decorator';
  import CookieDlg from "@/components/CookieDlg.vue";
  import Header from "@/components/Header.vue";
  import LandingSection from "@/components/LandingSection.vue";
  import decryptHref from "@/components/EmailDecryptor";
  import $ from "jquery";
  import Cookies from "js-cookie";
  import {gaSendPageview} from "@/components/Analytics";

  @Component({
    components: {CookieDlg, LandingSection, Header}
  })
  export default class AboutPrivacy2 extends Vue {
    private effectiveDate = '14 Nov 2024';
    private emails = {
      CONTACT: 'contact@ganttproject.biz'
    }
    private needsCookieConsent = Cookies.get("CookieConsent") !== "true";
    public $refs!: {
      cookieDlg: CookieDlg;
    };

    public mounted() {
      if (this.needsCookieConsent) {
        this.$refs.cookieDlg.show();
      }
      gaSendPageview();
    }

    public decrypt(event: Event) {
      decryptHref($(event.target));
    }
  }
